enum DataStatus {
  Default = 'default',
  Success = 'success',
  Empty = 'empty',
  Error = 'error',
}

export default DataStatus;
